import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { Spin, Table } from 'antd';
import { history } from 'kts-platform-frame/routes';
import { invoiceManage } from 'src/api';

const { formatTime, formatDate } = Field;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))
class MatchTable extends UIBasic<IProps, ModulesState> {
    public columns = [
        {
            title: '发票信息',
            dataIndex: 'itemCode',
            width: 600,
            render: (text, record) => {
                return (
                    <div className="ui-item-description">
                        <div
                            className="ui-item-left-space"
                            title={
                                record.supplierName +
                                ' 录入时间 ' +
                                formatTime(record.loggedDate)
                            }
                        >
                            <span className="supplier-name">
                                {record.supplierName}
                            </span>
                            {/* <span className="log-time">
                                录入时间:{" "}
                                {Lib.Util.Date.formatTime(
                                    record.loggedDate
                                )}
                            </span> */}
                        </div>
                        <div className="ui-item-left-space">
                            <span className="ui-item-info-tertiary">
                                <span>发票代码 </span>
                                <span>{record.invoiceCode}</span>
                            </span>
                            <span className="ui-item-info-tertiary">
                                <span>发票号码 </span>
                                <span>{record.invoiceNumber}</span>
                            </span>
                            <span className="ui-item-info-tertiary">
                                <span>开票日期 </span>
                                <span>
                                    {formatDate(
                                        record.invoiceDate
                                    )}
                                </span>
                            </span>
                        </div>
                    </div>
                );
            }
        },
        {
            title: '金额',
            dataIndex: 'amountWithoutTax',
            width: 180,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '税额',
            dataIndex: 'amountTax',
            width: 180,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '价税合计',
            dataIndex: 'amount',
            width: 180,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '合规状态',
            dataIndex: 'complianceStatus',
            width: 160,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '操作',
            dataIndex: 'amoun',
            width: 100,
            className: 'operate-column text-right',
            render: (text, record) => {
                return (
                    <div>
                        <span
                            className="click-item"
                            onClick={() => this.onDetail(record)}
                        >
                            详 情
                        </span>
                    </div>
                );
            }
        }
    ];
    public rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log("selectedRowKeys", selectedRowKeys);
            // this.modulesState.matchedInvoiceId = selectedRowKeys;
            this.setModulesState();
        },
        onSelect: (record, selected, selectedRows) => {
            if (selected) {
                // 选择一条记录

                ModulesAction.addMatched(record);
            } else {

                ModulesAction.minusMatched(record);
                // 取消选择一条记录
            }
            ModulesAction.getMatchedLength(selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
                console.log('44443333');
                for (let i = 0; i < selectedRows.length; i++) {
                    ModulesAction.addMatched(selectedRows[i]);
                }
                ModulesAction.getMatchedLength(selectedRows);
            } else {
                console.log('11112222');
                for (let i = 0; i < selectedRows.length; i++) {
                    ModulesAction.minusMatched(selectedRows[i]);
                }
                for (let i = 0; i < changeRows.length; i++) {
                    ModulesAction.minusMatched(changeRows[i]);
                }
                this.modulesState.matchedLength = 0;
                this.setModulesState();
                console.log(7899877789987);
            }

            this.setModulesState();
            // ModulesAction.getMatchedLength(selectedRows);
        },
        selectedRowKeys: this.modulesState.matchedInvoiceId,
    };
    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { loadingUrls } = this.props;
        return (
            <Spin spinning={loadingUrls.size > 0}>
                <Table
                    columns={this.columns}
                    rowSelection={this.rowSelection}
                    rowKey={(item) => item.incomeInvoiceBizId}
                    dataSource={this.modulesState.invoiceList}
                    pagination={false}
                    scroll={{ x: 1000 }}
                />
            </Spin>
        );
    }
    private onDetail = (record) => {
        let params = {
            invoiceManageId: record.incomeInvoiceBizId
        };
        invoiceManage.getInvoiceByBizId(this, params).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                var data = { invoiceDetail: response.res.invoiceDetail, realCheckTime: null };
                var path = {
                    pathname: `invoiceDetail/${record.incomeInvoiceBizId}`,
                    state: data,
                };
                history.push(path);
            }
        });
    }
}
export default MatchTable;



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Match.Table.tsx